import React, { useState } from "react";

const ContactSection = () => {
  const [formSuccess, setFormSuccess] = useState(false);
  const [formLoading, setFormLoading] = useState(false);

  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [purity, setPurity] = useState("");
  const [gram, setGram] = useState("");
  const [source, setSource] = useState("");

  const [errors, setErrors] = useState({
    name: "",
    phoneNumber: "",
    purity: "",
    gram: "",
    source: "",
  });

  const validateName = (value) => {
    if (!value.trim()) return "Name is required";
    if (value.trim().length < 2) return "Enter valid name";
    return "";
  };

  const validatePhoneNumber = (value) => {
    if (!value.trim()) return "Phone number is required";
    if (!/^\d{10}$/.test(value)) return "Phone number must be 10 digits";
    return "";
  };

  const validatePurity = (value) => {
    if (!value) return "Purity is required";
    return "";
  };

  const validateGram = (value) => {
    if (!value.toString().trim()) return "Gram is required";
    if (isNaN(value)) return "Gram must be a number";
    if (Number(value) <= 0) return "Gram must be greater than 0";
    return "";
  };

  const validateSource = (value) => {
    if (!value) return "Source is required";
    return "";
  };

  const validateForm = () => {
    const newErrors = {
      name: validateName(name),
      phoneNumber: validatePhoneNumber(phoneNumber),
      purity: validatePurity(purity),
      gram: validateGram(gram),
      source: validateSource(source),
    };

    setErrors(newErrors);
    return (
      !newErrors.name &&
      !newErrors.phoneNumber &&
      !newErrors.purity &&
      !newErrors.gram &&
      !newErrors.source
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formLoading) return;
    if (!validateForm()) return;

    setFormLoading(true);

    const payload = {
      name: name.trim(),
      phoneNumber: phoneNumber.trim(),
      purity,
      gram: gram.toString().trim(),
      source,
    };

    try {
      await fetch(
        "https://script.google.com/macros/s/AKfycbz1qxKRwtlJkUSO6R1lrs7o3cAAu-7nkfUVkRXA3gcupH4y88bfFbvKSmAGTVR5VH9O1w/exec",
        {
          method: "POST",
          mode: "no-cors",
          headers: {
            "Content-Type": "text/plain;charset=utf-8",
          },
          body: JSON.stringify(payload),
        }
      );

      setFormSuccess(true);
      setName("");
      setPhoneNumber("");
      setPurity("");
      setGram("");
      setSource("");
      setErrors({
        name: "",
        phoneNumber: "",
        purity: "",
        gram: "",
        source: "",
      });

      setTimeout(() => setFormSuccess(false), 8000);
    } catch (err) {
      console.error("Submit error:", err);
    } finally {
      setFormLoading(false);
    }
  };

  const contactInfo = [
    {
      icon: (
        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      ),
      title: "Address",
      content: (
  <>
        1st Floor, Satya Sai Complex,<br/>
     No. 224, 14th Cross, <br/>
     Sampige Road, Malleswaram,<br/>
      Bengaluru, Karnataka - 560003

  </>
),
    },
    {
      icon: (
        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
        </svg>
      ),
      title: "Contact Number",
      content: (
        <a href="tel:+917996800900" className="hover:underline">
          +91 7996 800 900
        </a>
      ),
    },
    {
      icon: (
        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      title: "Business Hours",
      content: (
        <>
          Monday - Saturday: 9:30 AM - 7:30 PM
          <br />
          Sunday: 10:00 AM - 6:00 PM
        </>
      ),
    },
    {
      icon: (
        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      ),
      title: "Email",
      content: (
        <>
          <a href="mailto:info@g1gold.com" className="hover:underline">
            info@g1gold.com
          </a>
          <br />
          <a href="mailto:g1goldcompany@gmail.com" className="hover:underline">
            g1goldcompany@gmail.com
          </a>
        </>
      ),
    },
  ];

  return (
    <>
      <section className="pt-8 pb-16 bg-gradient-to-br from-[#fff8e8] via-white to-[#fff3d6]">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <span className="inline-block px-4 py-2 bg-[#f6e7b0] text-[#9a7b2f] rounded-full text-sm font-semibold mb-6">
            Get In Touch
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Contact <span className="text-[#c89b2b]">G1 Gold</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Visit us for a free, no obligation gold evaluation. Our expert team is ready to assist you.
          </p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-8">Visit Us</h3>

              <div className="space-y-8">
                {contactInfo.map((info, index) => (
                  <div key={index} className="flex items-start gap-4">
                    <div
                      className="w-16 h-16 rounded-2xl flex items-center justify-center flex-shrink-0 shadow-lg"
                      style={{
                        background: "linear-gradient(135deg, #C89B2B 0%, #F2D36A 100%)",
                      }}
                    >
                      {info.icon}
                    </div>

                    <div>
                      <h4 className="font-semibold text-[#0f1d3a] text-lg mb-1">
                        {info.title}
                      </h4>
                      <p className="text-gray-600 leading-8">{info.content}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-10 rounded-2xl h-64 shadow-xl overflow-hidden">
                <img
                  src="images/contact/sanjana_contact0.webp"
                  alt="Smiling customer showing thumbs up at G1 Gold contact page"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>

            <div className="rounded-3xl p-10 shadow-xl border border-[#efe5c7] bg-[#fdfcf5]">
              <h3 className="text-3xl font-bold text-gray-900 mb-2">Contact Us</h3>
              <p className="text-gray-600 mb-2">
                Share your details below and our team will get in touch with you shortly.
              </p>
              <p className="mb-8 text-xs text-gray-500">
                We use your details only to respond to this enquiry. See our{" "}
                <a
                  href="https://g1gold.com/privacy"
                  className="font-medium text-[#c89b2b] hover:underline"
                >
                  privacy policy
                </a>
                .
              </p>

              <form onSubmit={handleSubmit} noValidate>
                <div className="space-y-6">
                  <div>
                    <label className="block text-sm font-medium text-[#0f1d3a] mb-2">Name *</label>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                        setErrors((prev) => ({
                          ...prev,
                          name: validateName(e.target.value),
                        }));
                      }}
                      className="w-full px-4 py-4 rounded-2xl border border-[#e7d88a] focus:border-[#c89b2b] focus:ring-2 focus:ring-[#f6e7b0] outline-none transition-all"
                      placeholder="Enter your name"
                    />
                    {errors.name && <p className="mt-1 text-sm text-red-500">{errors.name}</p>}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-[#0f1d3a] mb-2">Phone Number *</label>
                    <input
                      type="text"
                      value={phoneNumber}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                        setPhoneNumber(value);
                        setErrors((prev) => ({
                          ...prev,
                          phoneNumber: validatePhoneNumber(value),
                        }));
                      }}
                      className="w-full px-4 py-4 rounded-2xl border border-[#e7d88a] focus:border-[#c89b2b] focus:ring-2 focus:ring-[#f6e7b0] outline-none transition-all"
                      placeholder="Enter 10 digit phone number"
                    />
                    {errors.phoneNumber && <p className="mt-1 text-sm text-red-500">{errors.phoneNumber}</p>}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-[#0f1d3a] mb-2">Gold Purity *</label>
                    <select
                      value={purity}
                      onChange={(e) => {
                        setPurity(e.target.value);
                        setErrors((prev) => ({
                          ...prev,
                          purity: validatePurity(e.target.value),
                        }));
                      }}
                      className="w-full px-4 py-4 rounded-2xl border border-[#e7d88a] focus:border-[#c89b2b] focus:ring-2 focus:ring-[#f6e7b0] outline-none transition-all bg-white"
                    >
                      <option value="">Select Purity</option>
                      <option value="18K">18K</option>
                      <option value="20K">20K</option>
                      <option value="22K">22K</option>
                      <option value="24K">24K</option>
                    </select>
                    {errors.purity && <p className="mt-1 text-sm text-red-500">{errors.purity}</p>}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-[#0f1d3a] mb-2">Weight in Gram *</label>
                    <input
                      type="text"
                      value={gram}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9.]/g, "");
                        setGram(value);
                        setErrors((prev) => ({
                          ...prev,
                          gram: validateGram(value),
                        }));
                      }}
                      className="w-full px-4 py-4 rounded-2xl border border-[#e7d88a] focus:border-[#c89b2b] focus:ring-2 focus:ring-[#f6e7b0] outline-none transition-all"
                      placeholder="Enter gold weight"
                    />
                    {errors.gram && <p className="mt-1 text-sm text-red-500">{errors.gram}</p>}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-[#0f1d3a] mb-2">Source *</label>
                    <select
                      value={source}
                      onChange={(e) => {
                        setSource(e.target.value);
                        setErrors((prev) => ({
                          ...prev,
                          source: validateSource(e.target.value),
                        }));
                      }}
                      className="w-full px-4 py-4 rounded-2xl border border-[#e7d88a] focus:border-[#c89b2b] focus:ring-2 focus:ring-[#f6e7b0] outline-none transition-all bg-white"
                    >
                      <option value="">Select Source</option>
                      <option value="Google">Google</option>
                      <option value="Instagram/Facebook">Instagram/Facebook</option>
                      <option value="Direct Search">Direct Search</option>
                      <option value="Other">Other</option>
                    </select>
                    {errors.source && <p className="mt-1 text-sm text-red-500">{errors.source}</p>}
                  </div>

                  <button
                    type="submit"
                    disabled={formLoading}
                    className="w-full rounded-2xl py-4 font-semibold text-lg text-white shadow-lg transition disabled:opacity-60"
                    style={{
                      background: "linear-gradient(135deg, #EFCB57 0%, #C89B2B 100%)",
                    }}
                  >
                    {formLoading ? "Submitting..." : "Submit"}
                  </button>

                  {formSuccess && (
                    <p className="text-green-600 font-medium">
                      Submitted successfully.
                    </p>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactSection;